export const fonts = {
  gelica: 'font-gelica',
  'sofia-pro': 'font-sofia-pro',
};
